import { createStore, createCollectionStore } from 'aeria-ui'

export const funnelMessage = createStore((context) => {
  const state = reactive({
    modal: false,
  })

  return createCollectionStore(
    {
      $id: 'funnelMessage',
      state,
      actions: (state, actions) => ({
        openModal() {
          actions.clearItem()
          state.modal = true
        },
        closeModal() {
          actions.clearItem()
          state.modal = false
        },
      }),
    },
    context,
  )
})
